import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { ShowToast } from '../../../common/Toastr';
import fetchAPI from '../../../common/fetchAPI';
import { useTranslation } from 'react-i18next';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { getValueFromResource } from '../../../common/timeLiveFunction';

export const Api = () => {
    const [apiKey, setApiKey] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    useLayoutEffect(() => {

        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);


    useEffect(() => {
        getApiKey();
    }, [])

    const getApiKey = async () => {
        const response = await fetchAPI(`api/V2/Account/ApiKey`, 'Get', '', true);
        const json = await response.json();
        setApiKey(json.ApiKey);
    }

    const handleRegenerate = async () => {
        const response = await fetchAPI(`api/V2/Account/NewApiKey`, 'Get', '', true);
        const json = await response.json();
        setApiKey(json.NewApiKey[0]);
    };

    const handleDisable = () => {
        setApiKey('');
    };
    const handleEnable = async () => {
        const response = await fetchAPI(`api/V2/Account/NewApiKey`, 'Get', '', true);
        const json = await response.json();
        setApiKey(json.NewApiKey[0]);
    };

    const handleInputChange = (event: any) => {
        setApiKey(event.target.value);
    };

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setIsLoading(true);
        const response = await fetchAPI(`api/V2/Account/UpdateApiKey`, 'PUT', { ApiKey: apiKey }, true);
        const json = await response.json();
        if (json) {
            ShowToast("Api Key Updated Successfully", 'Success', "success", "toast-top-right")
            setIsLoading(false);
        }
        else {
            setIsLoading(false);
        }
    };
    const inputRef = useRef<HTMLInputElement>(null);
    const copyToClipboard = (e: any) => {
        e.preventDefault();
        if (inputRef.current) {
            inputRef.current.select();
            document.execCommand('copy');
        }
    };

    return (
        <>
            <div className="card card-custom">
                <div className="card-header " style={{ padding: '0rem 0rem' }}>
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('API Key')} */}
                        {getValueFromResource('API Key', dispatch, t)}

                    </h3>
                    
                        <div className='d-flex flex-stack '>
                            {IsEdit ? (
                                <button type="button"
                                    style={{ marginLeft: '-30px' }}
                                    className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                    onClick={(e: any) => handleSubmit(e)}
                                >
                                    {getValueFromResource('Update API', dispatch, t)}

                                </button>
                            ) : null}
                        </div>
                </div>
                <div className="card-body  flow" style={{ padding: '1rem 0rem' }}>
                    <div className='row'>
                        <div className="col-md-4 ">
                            <div className="alert alert-info" >
                                <label className="control-label">
                                    {/* {t('To Allow 3rd party Apps to Synchronize with TimeLive you need an API Key')} */}
                                    {getValueFromResource('To Allow 3rd party Apps to Synchronize with TimeLive you need an API Key', dispatch, t)}

                                </label>
                            </div>
                        </div>
                    </div>
                    {isLoading ?
                        <div className="col-md-12">
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                <span className='spinner-border spinner-border-md ms-2'></span>
                            </span>
                        </div>
                        : <>
                            <div className="row">
                                {apiKey && apiKey.length > 0 ? (
                                    <>
                                        <label className="fs-7 fs-7 fw-normal mb-3">
                                            {/* {t('API Key')} */}
                                            {getValueFromResource('API Key', dispatch, t)}

                                        </label>
                                        <div className="col-md-4 ">
                                            <input type="text" className="form-control fs-7 fw-normal fs-7 fw-normal" id='ApiKey' name='ApiKey'
                                                value={apiKey}
                                                readOnly
                                                onChange={(e) => handleInputChange(e)}
                                                ref={inputRef}
                                            />
                                        </div>
                                        <div className="col-md-12 mt-6">
                                            <button
                                                type='button'
                                                className="btn btn-sm btn-primary me-2"
                                                onClick={(e: any) => copyToClipboard(e)}
                                            >
                                                {/* {t('Copy')} */}
                                                {getValueFromResource('Copy', dispatch, t)}

                                            </button>

                                            <button
                                                type='button'
                                                className=" btn btn-sm btn-primary me-2"
                                                onClick={() => handleRegenerate()}
                                            >
                                                {/* {t('Regenerate')} */}
                                                {getValueFromResource('Regenerate', dispatch, t)}

                                            </button>
                                            <button
                                                type='button'
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleDisable()}>
                                                {/* {t('Disable API')} */}
                                                {getValueFromResource('Disable API', dispatch, t)}

                                            </button>


                                        </div>
                                    </>
                                ) : null}
                                <div>
                                    {apiKey && apiKey.length > 0 ? (
                                        null
                                    ) :
                                        <button type='button' className="btn btn-danger btn-sm" onClick={() => handleEnable()}>
                                            {/* {t('Enable API')} */}
                                            {getValueFromResource('Enable API', dispatch, t)}

                                        </button>
                                    }
                                </div>

                            </div>
                        </>
                    }
                </div>


            </div>
        </>
    )
}


